<template>
    <el-dialog
        title="日志详情"
        :visible.sync="visible"
        width="80%"
        top="5vh"
        :close-on-click-modal="false"
        @close="handleClose">
        <div v-if="currentLog">
            <el-descriptions :column="2" border style="margin-bottom: 20px;">
                <el-descriptions-item label="日志ID">{{ currentLog.id }}</el-descriptions-item>
                <el-descriptions-item label="日志类型">
                    <el-tag :type="getLogTypeTag(currentLog.logType)">{{ getLogTypeName(currentLog.logType) }}</el-tag>
                </el-descriptions-item>
                <el-descriptions-item label="用户ID">{{ currentLog.userId || '-' }}</el-descriptions-item>
                <el-descriptions-item label="用户名">{{ currentLog.username || '-' }}</el-descriptions-item>
                <el-descriptions-item label="操作描述" :span="2">{{ currentLog.operation }}</el-descriptions-item>
                <el-descriptions-item label="请求方法">
                    <el-tag :type="getMethodTag(currentLog.method)">{{ currentLog.method }}</el-tag>
                </el-descriptions-item>
                <el-descriptions-item label="请求URL">{{ currentLog.requestUrl }}</el-descriptions-item>
                <el-descriptions-item label="IP地址">{{ currentLog.ip }}</el-descriptions-item>
                <el-descriptions-item label="IP归属地">{{ currentLog.location || '-' }}</el-descriptions-item>
                <el-descriptions-item label="操作状态">
                    <enum-dict-label v-model="currentLog.status" dict-code="accessLogStatus" module-name="system" show-tag></enum-dict-label>
                </el-descriptions-item>
                <el-descriptions-item label="执行时长">
                    <span :style="{color: currentLog.executeTime > 1000 ? '#f56c6c' : '#67c23a'}">
                        {{ currentLog.executeTime }}ms
                    </span>
                </el-descriptions-item>
                <el-descriptions-item label="浏览器">{{ currentLog.browser || '-' }}</el-descriptions-item>
                <el-descriptions-item label="操作系统">{{ currentLog.os || '-' }}</el-descriptions-item>
                <el-descriptions-item label="记录时间" :span="2">{{ currentLog.createDate }}</el-descriptions-item>
            </el-descriptions>

            <el-divider content-position="left">请求参数</el-divider>
            <div style="margin-bottom: 15px;">
                <pre class="code-block">{{ currentLog.requestParams || '无' }}</pre>
            </div>

            <el-divider content-position="left">响应结果</el-divider>
            <div style="margin-bottom: 15px;">
                <pre class="code-block">{{ currentLog.responseResult || '无' }}</pre>
            </div>

            <el-divider content-position="left" v-if="currentLog.errorMsg">错误信息</el-divider>
            <div v-if="currentLog.errorMsg" style="margin-bottom: 15px;">
                <pre class="code-block error-block">{{ currentLog.errorMsg }}</pre>
            </div>

            <el-divider content-position="left" v-if="currentLog.userAgent">User-Agent</el-divider>
            <div v-if="currentLog.userAgent" style="margin-bottom: 15px;">
                <pre class="code-block">{{ currentLog.userAgent }}</pre>
            </div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">关闭</el-button>
            <el-button type="primary" @click="handleCopyLog">复制日志</el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {
    name: "AccessLogForm",
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        editData: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            currentLog: null
        }
    },
    watch: {
        visible(val) {
            if (val) {
                this.currentLog = this.editData;
            }
        },
        editData: {
            handler(val) {
                this.currentLog = val;
            },
            deep: true
        }
    },
    methods: {
        getLogTypeName(type) {
            const typeMap = {
                'LOGIN': '登录注册',
                'OPERATION': '操作日志',
                'API': '接口访问',
                'EXCEPTION': '异常日志'
            };
            return typeMap[type] || type;
        },
        getLogTypeTag(type) {
            const tagMap = {
                'LOGIN': 'primary',
                'OPERATION': 'success',
                'API': 'info',
                'EXCEPTION': 'danger'
            };
            return tagMap[type] || 'info';
        },
        getMethodTag(method) {
            const tagMap = {
                'GET': 'success',
                'POST': 'primary',
                'PUT': 'warning',
                'DELETE': 'danger'
            };
            return tagMap[method] || 'info';
        },
        handleClose() {
            this.$emit('update:visible', false);
        },
        handleCopyLog() {
            if (!this.currentLog) return;
            const logText = JSON.stringify(this.currentLog, null, 2);
            navigator.clipboard.writeText(logText).then(() => {
                this.$message.success('日志已复制到剪贴板');
            }).catch(() => {
                this.$message.error('复制失败，请手动复制');
            });
        }
    }
}
</script>

<style lang="less" scoped>
.code-block {
    background-color: #f5f7fa;
    padding: 15px;
    border-radius: 4px;
    overflow-x: auto;
    font-family: 'Consolas', 'Monaco', monospace;
    font-size: 13px;
    line-height: 1.6;
    max-height: 400px;
    overflow-y: auto;
    white-space: pre-wrap;
    word-break: break-all;
}

.error-block {
    background-color: #fef0f0;
    color: #f56c6c;
    border: 1px solid #fde2e2;
}
</style>
